/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Dispatch, SetStateAction, useState } from "react";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RejectReasonModal from "../../Modals/rejectReason";
import CustomPagination from "../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { formatDubaiDateTime } from "../../utils/dateTime";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { MEMBER_SORTING } from "../../utils/enums";

const CustomerListApproved = ({
  data,
  hasFetched,
  count,
  page,
  setPage,
  sortOrder,
  setSortOrder,
}: {
  data: any;
  hasFetched: boolean;
  count: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  sortOrder: string;
  setSortOrder: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [reason, setReason] = useState("");

  return (
    <>
      <div className="sorting_table cards table_cards">
        <div className="table_container">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th className="p_left">
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Name
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.Name_asc
                            ? "Name_desc"
                            : "Name_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th className="email_data">
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Email
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.Email_asc
                            ? "Email_desc"
                            : "Email_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Membership Type
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.MembershipType_asc
                            ? "MembershipType_desc"
                            : "MembershipType_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th>Status</th>
                <th>Payment Status</th>
                <th>
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Created Date
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.DateCreated_asc
                            ? "DateCreated_desc"
                            : "DateCreated_asc"
                        )
                      }
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.length ? (
                data?.map((row: any) => (
                  <React.Fragment key={row.id}>
                    <tr>
                      <td className="p_left">
                        <div
                          role="button"
                          tabIndex={0}
                          className="user_block click_action"
                          onClick={() =>
                            navigate(`/manage-customers/detail/${row?.id}`, {
                              state: {
                                status: "APPROVED",
                                memberType: row?.membershipType,
                              },
                            })
                          }
                        >
                          {row?.isVIP ? (
                            <img
                              className="vip"
                              src="/static/images/crown.png"
                            />
                          ) : null}

                          <figure>
                            <img
                              src="/static/images/user_placeholder.png"
                              alt=""
                            />
                          </figure>
                          <p>
                            <b>{row?.name || "-"}</b>
                          </p>
                        </div>
                      </td>
                      <td className="email_data">{row?.email || "-"}</td>
                      <td>
                        {row?.membershipType || ""}
                        {row?.membershipType === "Duo" && (
                          <IconButton
                            className="d_active"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevents triggering parent navigation if added
                              toggleExpand(row.id);
                            }}
                            size="small"
                            style={{ verticalAlign: "middle", marginLeft: 4 }}
                          >
                            {expandedRowId === row.id ? (
                              <ArrowDropDownIcon
                                style={{ transform: "rotate(180deg)" }}
                              />
                            ) : (
                              <ArrowDropDownIcon />
                            )}
                          </IconButton>
                        )}
                      </td>
                      <td>{row?.membership || ""}</td>
                      <td>
                        {row?.membership === "Paid" && row?.isPaid
                          ? "Paid"
                          : row?.membership === "Paid" && !row?.isPaid
                            ? "Pending"
                            : "-"}
                      </td>
                      <td>
                        {row?.createdDate
                          ? formatDubaiDateTime(row?.createdDate)
                          : "-"}
                      </td>
                    </tr>

                    {expandedRowId === row?.id && (
                      <tr>
                        <td colSpan={6}>
                          <div className="expanded-content p_inline_0">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td className="p_left">
                                    <div
                                      role="button"
                                      tabIndex={0}
                                      className="user_block click_action"
                                      onClick={() =>
                                        navigate(
                                          `/manage-customers/detail/${row?.partner?.id}`,
                                          {
                                            state: {
                                              status: "APPROVED",
                                              memberType: row?.membershipType,
                                            },
                                          }
                                        )
                                      }
                                    >
                                      {row?.isVIP ? (
                                        <img
                                          className="vip"
                                          src="/static/images/crown.png"
                                        />
                                      ) : null}
                                      <figure>
                                        <img
                                          src="/static/images/user_placeholder.png"
                                          alt=""
                                        />
                                      </figure>
                                      <p>
                                        <b>{row?.partner?.name || "-"}</b>
                                      </p>
                                    </div>
                                  </td>
                                  <td className="email_data">
                                    {row?.partner?.email}
                                  </td>
                                  <td>{row?.partner?.membershipType}</td>
                                  <td>{row?.partner?.membership || "-"}</td>
                                  <td>
                                    {" "}
                                    {row?.partner?.membership === "Paid" &&
                                    row?.partner?.isPaid
                                      ? "Paid"
                                      : row?.membership === "Paid" &&
                                          !row?.isPaid
                                        ? "Pending"
                                        : "-"}
                                  </td>
                                  <td>
                                    {row?.partner?.createdDate
                                      ? formatDubaiDateTime(
                                          row?.partner?.createdDate
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : hasFetched ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No Data Found
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>

      {data?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onClick={() => setOpen(false)}
        setReason={setReason}
        reason={reason}
      />
    </>
  );
};

export default CustomerListApproved;
